import indicationImage from "../../assets/images/Gyógytorna.jpg";
import "./IndicationsSection.css";

const indications = [
  "akut vagy krónikus mozgásszervi fájdalmak",
  "sportsérülések",
  "műtéti rehabilitáció",
  "valamint neurológiai panaszok esetén is",
];

function IndicationsSection() {
  return (
    <section className="indications-section">
      <div className="indications-section__content">
        <p className="eyebrow">Mikor javasolt a gyógytorna?</p>
        <h2>A gyógytorna hatékony segítséget nyújt</h2>

        <ul className="bullet-list indications-section__list">
          {indications.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <p className="indications-section__text">
          De nem csak a fájdalommal érdemes foglalkozni: A mozgásszervi
          problémák megelőzése érdekében azoknak is javasolt rendszeres
          mozgásterápia, akik ülőmunkát végeznek, vagy helytelen testtartásuk
          miatt hajlamosak nyak-, hát- vagy derékfájdalomra.
        </p>
      </div>

      <div
        className="indications-section__media"
        aria-hidden="true"
        style={{ backgroundImage: `url(${indicationImage})` }}
      />
    </section>
  );
}

export default IndicationsSection;
